export default __webpack_public_path__ + "static/media/signOutIcon.12674fb7.svg";